import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import gsap from 'gsap';
import LazyLoad from 'react-lazy-load';
import mediacentreImage from '../../assets/images/mediacentre-image.png';

const MeidaCentreSection = () => {
    const [ref, inView] = useInView({ threshold: 0.3 });
    const textRef1 = useRef(null);
    useEffect(() => {
        if (inView) {
            gsap.from(textRef1.current, {
                opacity: 0,
                x: -50,
                duration: 1,
                delay: 0.5,
            });
        }
    }, [inView]);
    return (
        <div ref={ref} className="container mx-auto max-w-[1597px] pt-[120px] sm:pt-[40px] px-[20px]">
            <div className={`w-full mx-auto overflow-hidden ${inView ? 'animate' : ''}`}>
                <div className="flex xs:flex-col">
                    <div className="w-full w-1/2 px-4 xs:px-0 flex items-center justify-end xs:justify-center">
                        <motion.div
                            className="bg-white w-[85%] sm:w-[100%] xs:w-full"
                            initial={{ opacity: 0, x: 50 }}
                            animate={inView ? { opacity: 1, x: 0 } : {}}
                            transition={{ duration: 0.5 }}
                        >
                            <h1
                                ref={textRef1}
                                className="text-[96px] 2xl:text-[76px] xl:text-[65px] lg:text-[55px] leading-[100px] 2xl:leading-[80px] xl:leading-[70px] lg:leading-[60px] font-[900] text-[#0174EB] mb-2 xxs:text-[45px] xxs:leading-[1]"
                            >
                                <motion.span
                                    initial={{ opacity: 0, x: -50 }}
                                    animate={inView ? { opacity: 1, x: 0 } : {}}
                                    transition={{ duration: 0.25, delay: inView ? 0.25 : 0 }}
                                >
                                    Media Centre
                                </motion.span>
                            </h1>
                        </motion.div>
                    </div>
                    <div className="w-full w-1/2 px-4 xs:px-0 flex items-center justify-end xs:justify-center">
                        <motion.div
                            className="bg-white p-6 pb-0"
                            initial={{ opacity: 0, x: -50 }}
                            animate={inView ? { opacity: 1, x: 0 } : {}}
                            transition={{ duration: 0.5 }}
                        >
                            <LazyLoad offset={100} once>
                                <motion.img
                                    src={mediacentreImage}
                                    alt="image"
                                    initial={{ opacity: 0, x: -50 }}
                                    animate={inView ? { opacity: 1, x: 0 } : {}}
                                    transition={{ duration: 0.5 }}
                                />
                            </LazyLoad>
                        </motion.div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MeidaCentreSection;
